import { motion } from "framer-motion";
import { Brain, Cpu, User } from "lucide-react";
import { useTranslation } from "../i18n/LanguageContext";

const ICONS = [Brain, Cpu, User];
const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } } };

export default function AISection() {
  const { t } = useTranslation();
  const a = t.ai;

  return (
    <section id="ai" className="py-24 md:py-32 relative bg-[#0A0A0B]" data-testid="ai-section">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#C9A96E]/5 blur-[180px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="mb-16"
        >
          <div className="flex items-center gap-4 mb-6">
            <motion.span
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: "easeOut" }}
              className="inline-block w-10 h-px bg-[#C9A96E]"
              style={{ transformOrigin: "left center" }}
            />
            <span className="fwd-eyebrow">{a.eyebrow}</span>
          </div>
          <h2 className="fwd-heading">
            {a.headline1}
            <br />
            {a.headline2}<span className="fwd-italic-gold">{a.headlineItalic}</span>
          </h2>
          <p className="fwd-body mt-6" style={{ maxWidth: "640px" }}>
            {a.intro}
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {a.features.map((feature, index) => {
            const Icon = ICONS[index] || Brain;
            return (
              <motion.div
                key={index}
                variants={item}
                className="p-8 fwd-card-hover"
                style={{
                  background: "#141417",
                  border: "1px solid #2A2A2E",
                  borderRadius: "2px",
                }}
                data-testid={`ai-feature-${index}`}
              >
                <div
                  className="w-12 h-12 mb-6 flex items-center justify-center"
                  style={{
                    background: "rgba(201, 169, 110, 0.1)",
                    border: "1px solid rgba(201, 169, 110, 0.3)",
                    borderRadius: "2px",
                  }}
                >
                  <Icon size={22} style={{ color: "#C9A96E" }} strokeWidth={1.5} />
                </div>
                <h3 className="fwd-heading mb-4" style={{ fontSize: "24px" }}>
                  {feature.title}
                </h3>
                <p className="fwd-body">{feature.description}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
